export default __webpack_public_path__ + "static/media/Saly-12.7b2ee200.png";